import React from 'react';
import './parcours.css'; 
import CollegeImage from '../../Images/Parcours/college_sada.png';
import LyceeVImage from '../../Images/Parcours/vilgenis.png';
import LyceeMImage from '../../Images/Parcours/Mayotte.png';
import OrsayImage from '../../Images/Parcours/orsay.png';

const Parcours = () => {
    return (
        <div class="parcours">
            <div class="grilleParcours">
                <div class="College"><img src={CollegeImage} /></div>
                <div class="LyceeV"><img src={LyceeVImage} /></div>
                <div class="LyceeM"><img src={LyceeMImage} /></div>
                <div class="Orsay"><img src={OrsayImage} /></div>
            </div>
        </div>
    );
};

export default Parcours;
